module.exports = __webpack_public_path__ + "img/insert-button.0570f789.svg";